import { useQuery } from '@apollo/client'
import { GET_FILTER_VALUES } from 'query/query'
import { useSelector } from 'react-redux'
import { selectUserSubscription } from 'reducers/subscription/selectors'
import { RootState } from 'reducers/store'

export const useFetchFilterValues = (variable_id: number, filterSchema: string) => {
  const context = useSelector((state: RootState) => selectUserSubscription(state))
  const { data, loading } = useQuery(GET_FILTER_VALUES, {
    variables: {
      variableId: variable_id,
      schema: filterSchema,
      filters: [],
      context,
    },
    fetchPolicy: 'no-cache',
    skip: !context || !variable_id,
  })
  return { data, loading }
}
